import { BizEntityTypeCategory, BizInformationTypes, FieldTypes, IBizEntity, IColsData, ItxnRelationshipLog, IUser } from "@optima-stride-ai/core";
import { AvatarComponent, EventSources, ExplorerInterceptsFor, IListViewColHeader, IListViewItem } from "@optima-stride-ai/optima-components";
import { convertConventionalIconToOSIcon, showFeatureNotImplemented, UtilService } from "../utils/util.service";
import { IMeasure } from "../transaction(Measure)/measure.model";

export function getListViewForMeasureLogs(data: ItxnRelationshipLog[], drillDown: (itemId: string) => void, selectClickedITem: (itemId: string) => void, isInModal: boolean, utilService:UtilService, deleteAction?:(itemId:string)=>void): IListViewItem<ItxnRelationshipLog>[] {
    let items: IListViewItem<ItxnRelationshipLog>[] = [];
     let trashIcon = 'oscOptions'
     let menuToolTIp = 'Action'
    for (let i = 0; i < data.length; i++) {
        let d = data[i];
        let dynamicColumns: IColsData[] = [];
        if (d.logFieldValues) {
            for (let j = 0; j < d.logFieldValues.length; j++) {
                let logField = d.logFieldValues[j];
                if (logField.fieldMeta.viewInList) {
                    let value = logField.value;
                    // if(logField.fieldMeta.type === FieldTypes.date){
                    //     value = value.split('T')[0] + ' ' + value.split('T')[1];
                    // }
                    dynamicColumns.push({ key: logField.fieldMeta.name, label: logField.fieldMeta.label, value: value, metaData: { name: logField.fieldMeta.name, label: '', type: FieldTypes.text }, bizInformationType: BizInformationTypes.text });
                }
            }
        }
        let item: IListViewItem<ItxnRelationshipLog> = {
            id: d.id.toString(),
            itemActions: [
                {
                    label: `itemClicked`, icon: '', action: (item: IListViewItem<ItxnRelationshipLog> | undefined) => {
                        if (item?.id) {
                            drillDown(item.id);
                        }
                    }, eventSource: EventSources.DoubleClick
                }
            ],
            columns: [
                { key: 'date', label: 'L1', value:new Date(d.date).toLocaleDateString(), metaData: { name: 'date', label: '', type: FieldTypes.text }, bizInformationType: BizInformationTypes.text },
                // { key: 'col2', label: 'L2', value: d.value, metaData: { name: 'col2', label: '', type: FieldTypes.text }, bizInformationType: BizInformationTypes.text },
                // { key: 'col3', label: 'L3', value: d.unit, metaData: { name: 'col3', label: '', type: FieldTypes.text }, bizInformationType: BizInformationTypes.text },
                ...dynamicColumns,
               // { key: 'col7', label: 'L7', value: d.author?.avatar || 'https://ui-avatars.com/api/?name=Optima+Stride&background=0D8ABC&color=fff', metaData: { name: 'col7', label: 'L7', type: FieldTypes.text }, optimaHTMLElement: getAvatarEle(), bizInformationType: BizInformationTypes.image },
            ],
            actions: deleteAction ? [
                { label: 'Delete', icon:'cilTrash', tooltip: 'Delete Measure Log', action: (item: IListViewItem<ItxnRelationshipLog> | undefined) => {
                    if (deleteAction && item?.id) {
                        deleteAction(item.id);
                    }
                }, eventSource:EventSources.Click
                },
            ]: [],
              layout: {
                header: {
                    colsData: [
                        { key: 'col1', label: 'L1', value: d.bizEntity.icon, metaData: { name: 'col1', label: 'L1', type: FieldTypes.text }, bizInformationType: BizInformationTypes.icon },
                        { key: 'col2', label: 'L2', value: d.bizEntity.name, metaData: { name: 'col2', label: 'L2', type: FieldTypes.text }, bizInformationType: BizInformationTypes.text },
                    ],
                    actions: !isInModal ? [
                        { label: 'Delete', icon:'cilTrash', tooltip: 'Delete Measure Log', action: (item: ItxnRelationshipLog | undefined) => {
                    if (deleteAction && item?.id) {
                        deleteAction(item.id.toString());
                    }
                }, eventSource:EventSources.Click
                },
                    ] : [],
                },
                content: {
                    sections: [{ key: 'section1', content: buildCardsContent(d), contentType: 'html' }]
                },
                footer: {
                    colsData: [
                        { key: 'col7', label: 'L7', value: {component: AvatarComponent, inputs: { users: d.bizEntity.ownerDetail, size: 'md', viewType: 'single', onMessage: (user: IUser) => showFeatureNotImplemented('Messaging'), onCall: (user: IUser) => showFeatureNotImplemented('Call') }}, metaData: { name: 'col7', label: 'L7', type: FieldTypes.component }, bizInformationType: BizInformationTypes.component },
                    ]
                },
                maxHeight: '20rem',
                minHeight: '20rem',
                maxWidth: '20rem',
                minWidth: '20rem',
            }
        };
        items.push(item);
    }
    return items;
}

export function getColHeadersForTxnLog(data: IMeasure): IListViewColHeader[] {
    let headers = data.logFieldsMeta;
    let colHeaders: IListViewColHeader[] = [];
    if (headers) {
      colHeaders = []
      headers.forEach(header => {
        if (header.viewInList) {
          colHeaders?.push({
            key: header.name,
            label: header.label,
          });
        }
      });
    }

    colHeaders.unshift({ key: 'date', label: 'Date' });
    return colHeaders;
}

export function getColHeadersForTransactionLog(data: IBizEntity): IListViewColHeader[] {
    if(!data.type.txnLogAdditionalField){
        return [];
    }
    let headers = data.type.txnLogAdditionalField;
    let colHeaders: IListViewColHeader[] = [];
    if (headers) {
      colHeaders = []
      headers.forEach(header => {
        if (header.viewInList) {
          colHeaders?.push({
            key: header.name,
            label: header.label,
          });
        }
      });
    }

    colHeaders.unshift({ key: 'date', label: 'Date' });
    return colHeaders;    
}
export function buildCardsContent(entity: ItxnRelationshipLog) {
    // console.log('Building card content for entity:', entity);

    
    // let progressKPILatestStatus = findLatestKPIProgressStatus(entity.progressStatus || []);
    const val = entity.logFieldValues && entity.logFieldValues[0]?.fieldMeta?.name === 'status' ? entity.logFieldValues[0]?.value : '';
    const len = Math.max((val?.toString() ?? '').length, 1);
    const cq = Math.max(14, Math.min(Math.round(56 / len + 8), 28));
    return `
    <c-card-body class="p-0 d-flex justify-content-center align-items-center" style="container-type: inline-size; overflow: hidden; height: 100%; width: 100%;">
 
            <div style="white-space: nowrap; font-size: ${cq}cqi; font-weight: 700;">
                ${val}
            </div>

        
    </c-card-body>
    `;
};